module.exports = __webpack_public_path__ + "media/images/sp/stores/funabashi/funabashi_concept_01-4dceaf02d88f9e981ebcfab2d0aceb80.jpg";